module.exports = __webpack_public_path__ + "static/media/exchange_games_bg_mobile.1ddc3444.jpg";